module.exports = __webpack_public_path__ + "static/hexa1-8c60ab70de19f3d0087bd8cd8b2d7e87.svg";